<template>
	<div v-if="selectedConnectorFilters && selectedConnectorHeaders">
		<connector-filters
			:filterType="connectorParentFilterType"
			v-if="selectedConnectorFilters"
		/>
		<connector-headers
			:headerType="connectorParentHeaderType"
			v-if="selectedConnectorHeaders"
		/>
		<connector-filters
			:filterType="connectorChildFilterType"
			v-if="selectedConnectorFilters"
		/>
		<connector-headers
			:headerType="connectorChildHeaderType"
			v-if="selectedConnectorHeaders"
		/>
	</div>
</template>

<script>
import ConnectorFilters from './filters/ConnectorFilters.vue';
import ConnectorHeaders from './headers/ConnectorHeaders.vue';

import { gridViewConnectorHeaderType } from '../../../../enums/gridViewConnectorHeaderType';
import { gridViewConnectorFilterType } from '../../../../enums/gridViewConnectorFilterType';
import { mapGetters } from 'vuex';
import {
	ConnectorHeadersGetters,
	ConnectorFiltersGetters,
} from '../../../../store/getters';
export default {
	name: 'ConnectorDetails',
	components: {
		ConnectorFilters,
		ConnectorHeaders,
	},
	computed: {
		...mapGetters({
			selectedConnectorHeaders: [
				ConnectorHeadersGetters.SELECTED_CONNECTOR,
			],
			selectedConnectorFilters: [
				ConnectorFiltersGetters.SELECTED_CONNECTOR,
			],
		}),
		connectorParentHeaderType() {
			return gridViewConnectorHeaderType.Parent;
		},
		connectorChildHeaderType() {
			return gridViewConnectorHeaderType.Child;
		},
		connectorParentFilterType() {
			return gridViewConnectorFilterType.Parent;
		},
		connectorChildFilterType() {
			return gridViewConnectorFilterType.Child;
		},
	},
};
</script>
